// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Lightbulb: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42 60.4"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M34.8 6.2C31 2.8 25.9.8 20.9.8 11.1.8.6 8.6.6 21.1c0 6.2 2.4 11.4 7.2 15.5l.2.2c3.3 3.6 3.4 4.2 3.5 5.7v1.4c0 .8 0 2.5 2 3.1L28 50.2c.1 0 .2.1.3.1.4 0 .8-.3.9-.8l.2-.7c.2-.5-.1-1-.8-1.2l-14.4-3.2v-1.8c0-2.5-.6-3.7-4.3-7.8l-.5-.5c-3.9-3.5-5.8-7.9-5.8-13 0-10.9 9.1-17.6 17.6-17.6 8.7 0 17.6 6.6 17.6 17.6 0 6.8-3.3 10.6-5.8 12.9h-.1l-.7.7c-3.9 4.2-4.3 5.3-4.3 7.7l-7.1-1.7c-.2-.1-.5-.1-.7 0-.2.1-.4.4-.5.7l-.2.7c-.1.2-.1.5 0 .7.1.2.4.4.7.5l7.4 1.7h.1c.3.1 1.2.3 2-.3.8-.4.9-1.2 1-1.9v-.4c0-1.5 0-2 3.5-5.7l.1-.1c4.9-4.1 7.4-9.3 7.4-15.5-.3-6-2.6-11.3-6.8-15.1zm-6.4 46.1l-14.2-3.2c-.3-.1-.6-.1-.9.1-.2.2-.4.4-.4.7l-.2.6c-.1.3-.1.6.1.8.1.2.3.3.6.4L27.7 55c.1 0 .2.1.3.1.1 0 .3 0 .4-.1.2-.1.4-.4.5-.7l.2-.7c.3-.6 0-1.1-.7-1.3zm-1.8 4.5l-11.5-2.6c-.5-.2-1 .1-1.2.7l-.2.7c-.1.3-.1.6.1.9.2.2.4.4.7.4l11.4 2.6c.1 0 .2.1.3.1.4 0 .8-.3.9-.8l.2-.7c.3-.6 0-1.1-.7-1.3z"/></svg>;
};

export default React.memo(Lightbulb);
